import { render, staticRenderFns } from "./ReplayMessage.vue?vue&type=template&id=7146d12c&"
import script from "./ReplayMessage.vue?vue&type=script&lang=js&"
export * from "./ReplayMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReplayMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports